import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'pixl-card1',
  imports: [
    MatCardModule,
  ],
  templateUrl: './card1.component.html',
  styleUrl: './card1.component.scss'
})
export class Card1Component {

}
